import { render, staticRenderFns } from "./IncomeHistory.vue?vue&type=template&id=2de50936&scoped=true"
import script from "./IncomeHistory.vue?vue&type=script&lang=js"
export * from "./IncomeHistory.vue?vue&type=script&lang=js"
import style0 from "./IncomeHistory.vue?vue&type=style&index=0&id=2de50936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de50936",
  null
  
)

export default component.exports